﻿module Client.ContractPage.CostOfConstruction.Collapsed

open Fable.React
open Fable.React.Props
open ContractPageModel
open Fulma
open Fable.FontAwesome
open Shared
open Feliz

let CostsCollapsed =
  React.memo (
    "CostsCollapsed",
    (fun (props: {| AppSettings: ContractSettings
                    ContractId: ContractId
                    JobPhaseCosts: JobPhaseCosts
                    Dispatch: Msg -> unit
                    Key: string |}) ->
      tr [ OnClick (fun _ ->
             CostOfConstructionPhaseExpansionToggled(props.ContractId, props.JobPhaseCosts.Phase.Code)
             |> props.Dispatch) ] [
        yield
          td [ Style [
                 TextAlign TextAlignOptions.Right
               ] ] [
            strong [] [
              props.JobPhaseCosts.Phase.Code |> str
            ]
          ]
        yield
          td [] [
            a [] [
              div [ Style [
                      Display DisplayOptions.Flex
                      JustifyContent "space-between"
                    ] ] [
                strong [] [
                  props.JobPhaseCosts.Phase.Desc |> str
                ]
                Icon.icon [ Icon.Props [ Style [ Color "#b5b5b5" ] ] ] [
                  Fa.i [ Fa.Solid.ChevronDown ] []
                ]
              ]
            ]
          ]
        yield! Utils.totalColumns props.AppSettings props.JobPhaseCosts.Costs
      ]),
    (fun (props: {| AppSettings: ContractSettings
                    ContractId: ContractId
                    JobPhaseCosts: JobPhaseCosts
                    Dispatch: Msg -> unit
                    Key: string |}) -> $"CostsCollapsed-%s{props.Key}")
  )